import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ContentChildren, QueryList, AfterViewInit, OnDestroy, HostBinding, ContentChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatTabHeaderPosition, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader } from '@angular/material/tabs';
import { CustomPageTabComponent } from '../custom-page-tab/custom-page-tab.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { CustomizationFrameworkService } from '../customization-framework.service';
import { take } from 'rxjs/operators';
import { EFormControl } from '../../../shared-components/e-forms/e-form-control.model';
import { CSTField, CustomFieldDataObject } from '../models/custom-data-field.model';
import { YearService } from '../../../shared-components/year/year.service';
import { cloneDeep } from 'lodash';
import { CustomDesignPage } from '../../../admin360/customization/models/custom-design-page.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'custom-page-tab-group',
  templateUrl: './custom-page-tab-group.component.html',
  styleUrls: ['./custom-page-tab-group.component.css']
})
export class CustomPageTabGroupComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostBinding('class') get classes() {
    let classes = '';
    if (this.isChildTabs) {
      classes += 'childTabs';
    }
    if (!this.showTabs) {
      classes += ' hideTabs';
    }
    return classes;
  }

  @Input() animationDuration = '0ms';
  @Input() backgroundColor: ThemePalette;
  @Input() color: ThemePalette;
  @Input() disableRipple: boolean;
  @Input() dynamicHeight: boolean;
  @Input() headerPosition: MatTabHeaderPosition;
  @Input() selectedIndex: number | null;
  private _isChildTabs: boolean;
  @Input() set isChildTabs(value: boolean) {
    this._isChildTabs = value;
  }
  get isChildTabs(): boolean {
    return this._isChildTabs;
  }
  private _dataStore: CustomFieldDataObject[] = [];
    public get dataStore(): CustomFieldDataObject[] {
        return this._dataStore;
    }
    @Input() public set dataStore(value: CustomFieldDataObject[]) {
        this._dataStore = value;
        if (this.tabs) {
          this.tabs.forEach(tab => {
            tab.dataStore = value;
          });
        }
    }

  @Output() animationDone: EventEmitter<void> = new EventEmitter<void>();
  @Output() focusChange: EventEmitter<MatTabChangeEvent> = new EventEmitter<MatTabChangeEvent>();
  @Output() selectedIndexChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() selectedTabChange: EventEmitter<MatTabChangeEvent> = new EventEmitter<MatTabChangeEvent>();
  @Output() tabChangeErrors: EventEmitter<ErrorList[]> = new EventEmitter<ErrorList[]>();

  private _tabGroup: MatTabGroup;
  @ViewChild(MatTabGroup, { static: true })
  public set tabGroup(value: MatTabGroup) {
    this._tabGroup = value;
    this.subscriptions.push(this._tabGroup.selectedTabChange.subscribe(evt => this.handleSelectedTabChange(evt)));
    this._tabGroup._handleClick = this.interceptTabChange.bind(this);
  }

  public get tabGroup(): MatTabGroup {
    return this._tabGroup;
  }

  private _tabs: QueryList<CustomPageTabComponent>;
  @ContentChildren(CustomPageTabComponent)
  protected set tabs(value: QueryList<CustomPageTabComponent>) {
    this._tabs = value;
    if (this._tabs) {
      this.setTabs();
      if (this._tabs.length > 1) {
        this.showTabs = true;
      }
      else {
        this.showTabs = false;
      }
      if (this._tabs.length > 0) {
        this._tabs.forEach(tab => {
          tab.dataStore = this.dataStore;
          tab.tabGroupIsGettingMetadata = true;
          this.subscriptions.push(tab.isDirtyChange.subscribe(isDirty => {
            this.isDirtyChange.emit(isDirty);
          }));
        });
        setTimeout(() => {
          this.getMetadata();
        }, 0);
      }
    }
  }

  protected get tabs(): QueryList<CustomPageTabComponent> {
    return this._tabs;
  }

  public get isDirty(): boolean {
    let result = false;
    if (this.tabs) {
      this.tabs.forEach(tab => {
        if (tab.isDirty) {
          result = true;
        }
      });
    }
    return result;
  }
  @Input() public set isDirty(value: boolean) {
    if (this.tabs) {
      this.tabs.forEach(tab => {
        tab.isDirty = value;
      });
    }
  }

  @Output() isDirtyChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  subscriptions: Subscription[] = [];
  errors: ErrorList[] = [];
  doNotValidate = false;
  previousTabIndex = 0;
  showTabs = false;


  constructor(
    private customizationFrameworkService: CustomizationFrameworkService,
    private yearService: YearService
  ) {
    if (!this.dataStore) {
      this.dataStore = this.customizationFrameworkService.getNewDataStore();
    }
  }

  ngOnInit() {
    // this.getMetadata();
  }

  ngOnDestroy() { }

  public ngAfterViewInit() {

  }

  private getMetadata() {
    if (this._tabs) {
      const designPageEvents: Observable<CustomDesignPage>[] = [];
      this._tabs.forEach(tab => {
        if (!tab.pageComponent && !tab.designPageComponent) {
          tab.tabGroupIsGettingMetadata = false;
        }
        else if (tab.designPageComponent && !tab.designPageComponent.designPage) {
          designPageEvents.push(tab.designPageComponent.observabledesignPageStream$);
        }
      });
      if (designPageEvents.length > 0) {
        // we need to wait for the design pages to be loaded before we can get the metadata
        forkJoin(designPageEvents).pipe(take(1)).subscribe(r => {
          this.getMetadata();
        });
      }
      else {
        const controls = this.getControlsOnAllTabs();
        const fieldNames = controls.map(o => o.CustomFieldName);
        if (fieldNames && fieldNames.length > 0) {
          if (!this.customizationFrameworkService.customDataFields) {
            this.customizationFrameworkService.customDataFields = [];
          }
          for (let i = fieldNames.length; i >= 0; i--) {
            if (this.customizationFrameworkService.customDataFields.find(o => o.FieldName == fieldNames[i])) {
              fieldNames.splice(i, 1);
            }
          }
          if (fieldNames.length > 0) {
            this.customizationFrameworkService.massGetCustomDataFieldByFieldName(fieldNames, this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).pipe(take(1)).subscribe(fields => {
              fields.forEach(f => {
                if (this.customizationFrameworkService.customDataFields.find(o => o.ID == f.ID) == null) {
                  this.customizationFrameworkService.customDataFields.push(f);
                }
              });
              this.customizationFrameworkService.observableFieldMetaDataRetrieved.next(fields);
              this.getValues();
            });
          }
          else {
            this._tabs.forEach(tab => {
              if (tab.tabGroupIsGettingMetadata == true) {
                tab.tabGroupIsGettingMetadata = false;
              }
            });
            this.getValues();
          }
        }
      }
    }
  }

  private getValues() {
    const fieldsToGet: CSTField[] = [];
    const allControls: EFormControl[] = [];
    if (this.tabs) {
      this.tabs.forEach(tab => {
        let controls: EFormControl[] = [];
        if (tab.designPageComponent) {
          controls = tab.designPageComponent.getAllCustomFields().filter(o => o.CustomFieldAllowControlToHandleOwnData);
          controls.forEach(c => {
            c.DesignPageIndex = tab.designPageComponent.designPageIndex;
            c.CustomFieldMasterId = tab.designPageComponent.masterId;
          });
        }
        else if (tab.pageComponent) {
          controls = tab.pageComponent.getAllCustomFieldControls();
          controls.forEach(c => {
            c.DesignPageIndex = tab.pageComponent.customPageIndex;
            c.CustomFieldMasterId = tab.pageComponent.masterId;
          });
        }
        controls.forEach(o => {
          if (o.Editable == null) {
            o.Editable = true;
          }
          const c = allControls.find(x => x.CustomFieldName == o.CustomFieldName);
          if (c) {
            c.Editable = c.Editable || o.Editable;
            c.CustomFieldAllowControlToHandleOwnData = c.CustomFieldAllowControlToHandleOwnData || o.CustomFieldAllowControlToHandleOwnData;
          }
          else {
            allControls.push(o);
          }
          const field = cloneDeep(this.customizationFrameworkService.customDataFields.find(f => f.FieldName == o.CustomFieldName));
          if (field) {
            field.MasterId = o.CustomFieldMasterId;
            if (o.CustomFieldAllowControlToHandleOwnData && this.customizationFrameworkService.userCanViewField(field, o.Editable, o.CustomFieldAllowControlToHandleOwnData)) {
              const dataObj = this.getCustomFieldDataObject(field);
              if (dataObj && dataObj.Value != null) {
                // we already have stored data, no need to get any
              }
              else if (o.CustomFieldMasterId > 0) {
                fieldsToGet.push(field);
              }
            }
          }
        });
      });
    }
    if (fieldsToGet.length > 0) {
      this.customizationFrameworkService.massGetCustomDataFieldValue(this.yearService.defaultYear.SiteYearId, fieldsToGet).pipe(take(1)).subscribe(fields => {
        fields.forEach(f => {
          const control = allControls.find(o => o.CustomFieldName == f.FieldName);
          this.customizationFrameworkService.persistValue(f, control.Editable, control.CustomFieldAllowControlToHandleOwnData, f.MasterId, this.dataStore, false);
        });
        this.customizationFrameworkService.observableFieldValuesRetrieved.next(fields);
      });
    }
    else {
      this.customizationFrameworkService.observableFieldValuesRetrieved.next([]); // tell custom pages they can load their controls
    }
  }

  getControlsOnAllTabs(): EFormControl[] {
    let controls: EFormControl[] = [];
    if (this.tabs) {
      this.tabs.forEach(tab => {
        if (tab.designPageComponent) {
          const dpControls = tab.designPageComponent.getAllCustomFields();
          dpControls.forEach(c => { c.DesignPageIndex = tab.designPageComponent.designPageIndex; });
          controls = controls.concat(dpControls);
        }
        else if (tab.pageComponent) {
          const cpControls = tab.pageComponent.getAllCustomFieldControls();
          cpControls.forEach(c => { c.DesignPageIndex = tab.pageComponent.customPageIndex; });
          controls = controls.concat(cpControls);
        }
      });
    }
    return controls;
  }

  getCustomFieldDataObject(field: CSTField): CustomFieldDataObject {
    return this.customizationFrameworkService.getCustomFieldDataObject(field, field.MasterId, this.dataStore);
  }

  setTabs() {
    setTimeout(() => {
      const matTabsFromQueryList = this.tabs.map((tab) => tab.matTab);
      const list = new QueryList<MatTab>();
      list.reset([matTabsFromQueryList]);
      this.tabGroup._allTabs = list;
      this.tabGroup._tabs = list;
      this.tabGroup.ngAfterContentInit();
      if (this.tabs && this.tabs.length > 0 && this.tabs.first.pageComponent) {
        // if the first tab is a custom page then we need to tell it to load its form.
        this.tabs.first.pageComponent.canShowForm = true;
      }
    }, 0);
  }

  interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
    if (!tab.disabled) {
      const previousTab = this.tabs.toArray()[this.previousTabIndex];
      if (previousTab) {
        // const errors = this.validateSinglePage(previousTab.label);
        const errors = [];
        if (errors.length == 0) {
          if (idx >= 0) {
            const cstTab = this.tabs.toArray()[idx];
            if (cstTab) {
              if (cstTab.pageComponent) {
                cstTab.pageComponent.canShowForm = true;
              }
            }
          }
          if (previousTab.pageComponent) {
            previousTab.pageComponent.canShowForm = false;
          }
          return MatTabGroup.prototype._handleClick.apply(this.tabGroup, arguments);
        }
        else {
          this.tabChangeErrors.emit(errors);
          return null;
        }
      }
      else {
        if (idx >= 0) {
          const cstTab = this.tabs.toArray()[idx];
          if (cstTab) {
            if (cstTab.pageComponent) {
              cstTab.pageComponent.canShowForm = true;
            }
          }
        }
        if (previousTab.pageComponent) {
          previousTab.pageComponent.canShowForm = false;
        }
        return MatTabGroup.prototype._handleClick.apply(this.tabGroup, arguments);
      }
    }
  }

  public validateAllPages(): ErrorList[] {
    this.errors = [];
    this.tabs.forEach(tab => {
      let errors: ErrorList[] = [];
      if (tab.pageComponent) {
        errors = tab.pageComponent.validateControls();
      }
      else if (tab.designPageComponent) {
        errors = tab.designPageComponent.validateControls();
      }
      if (tab.validateFunction) {
        errors = errors.concat(tab.validateFunction());
      }
      errors.forEach(e => {
        e.clickCallback = () => {
          this.selectTabByName(tab.label);
        };
      });
      if (!this.tabGroup.selectedIndex || this.tabGroup.selectedIndex < 0 || this.tabs[this.tabGroup.selectedIndex] != tab) {
        // these errors are not for the selected tab.  Add the tab name to the error
        errors.forEach(e => {
          e.fieldName = tab.label.toUpperCase() + (e.fieldName ? ' - ' + e.fieldName : '');
        });
      }
      this.errors = this.errors.concat(errors);
    });
    return this.errors;
  }

  public validateSinglePage(tabName: string): ErrorList[] {
    let errors: ErrorList[] = [];
    const index = this.getTabIndexByName(tabName);
    if (index >= 0) {
      const tab = this.tabs.toArray()[index];
      if (tab.pageComponent) {
        errors = tab.pageComponent.validateControls();
      }
      else if (tab.validateFunction) {
        errors = tab.validateFunction();
      }
    }
    return errors;
  }

  public saveAllCustomPages(): ErrorList[] {
    this.validateAllPages();
    if (this.errors.length == 0) {
      this.customizationFrameworkService.saveAllCustomFieldsInMemory(this.dataStore);
    }
    return this.errors;
  }

  selectTabByName(tabName: string) {
    const i = this.getTabIndexByName(tabName);
    this.tabGroup.selectedIndex = this.getTabIndexByName(tabName);
    const tab = this.tabs.toArray()[i];
    if (tab.pageComponent) {
      tab.pageComponent.showErrorsOnInitialize = true;
      tab.pageComponent.canShowForm = true;
    }
  }

  getTabIndexByName(tabName: string): number {
    return this.tabGroup._tabs.toArray().findIndex(o => o.textLabel.toUpperCase() == tabName.toUpperCase());
  }

  handleSelectedTabChange(evt: MatTabChangeEvent) {
    this.selectedTabChange.emit(evt);
    this.previousTabIndex = evt.index;
  }

  refreshValuesForAllCustomPages() {
    this.getValues();
  }

  clearStoredData(masterId: number, objectId: number, fieldId: number) {
    let i = this.dataStore.length;
    while (i--) {
      const dataObj = this.dataStore[i];
      if ((masterId == null || dataObj.MasterId == masterId)
        && (objectId == null || dataObj.ObjectID == objectId)
        && (fieldId == null || dataObj.CustomFieldID == fieldId)) {
        this.dataStore.splice(i, 1);
      }
    }
  }

  updateMasterIDForPersistedData(objectId: number, newMasterId: number, oldMasterId?: number) {
    this.dataStore.forEach(f => {
      if (f.ObjectID == objectId && (oldMasterId == null || f.MasterId == oldMasterId)) {
        const field = this.customizationFrameworkService.customDataFields.find(o => o.ID == f.CustomFieldID && o.ObjectID == objectId);
        if (field) {
          f.MasterId = newMasterId;
        }
      }
    });
  }

}
